module.exports = __webpack_public_path__ + "img/dink-bedroom-2.1104e264.jpeg";